import { render, staticRenderFns } from "./crm-refresh.vue?vue&type=template&id=4471d8fa&"
import script from "./crm-refresh.vue?vue&type=script&lang=js&"
export * from "./crm-refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports